/**
 * Fechas Twilio lista/socket: YYYY-MM-DD HH:mm:ss en America/Mexico_City.
 * Evita toISOString()/Z que desordena vs envíos locales.
 */

const RE_MX = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/

export function formatFechaMexicoFront (value = Date.now()) {
  let d
  if (value instanceof Date) {
    d = value
  } else if (typeof value === 'number' && Number.isFinite(value)) {
    d = new Date(value)
  } else if (value != null && String(value).trim() !== '') {
    const s = String(value).trim()
    if (RE_MX.test(s)) return s
    d = new Date(s.includes('T') ? s : (RE_MX.test(s) ? `${s.replace(' ', 'T')}-06:00` : s.replace(' ', 'T')))
    if (!Number.isFinite(d.getTime()) && RE_MX.test(s)) {
      d = new Date(`${s.replace(' ', 'T')}-06:00`)
    }
  } else {
    d = new Date()
  }
  if (!Number.isFinite(d.getTime())) d = new Date()
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Mexico_City',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).formatToParts(d)
    const get = (type) => {
      const p = parts.find((x) => x.type === type)
      return p ? p.value : '00'
    }
    const hour = get('hour') === '24' ? '00' : get('hour')
    return `${get('year')}-${get('month')}-${get('day')} ${hour}:${get('minute')}:${get('second')}`
  } catch (_) {
    const p = (n) => String(n).padStart(2, '0')
    const local = new Date(d.getTime() - 6 * 60 * 60 * 1000)
    return `${local.getUTCFullYear()}-${p(local.getUTCMonth() + 1)}-${p(local.getUTCDate())} ${p(local.getUTCHours())}:${p(local.getUTCMinutes())}:${p(local.getUTCSeconds())}`
  }
}

export function fechaUltimoMensajeMs (chat) {
  if (!chat) return 0
  const raw =
    chat.fecha_ultimo_mensaje
    || chat.ultimmensaje
    || chat.ultimomensaje
    || chat.fecha_creacion
    || ''
  if (!raw) return 0
  if (typeof raw === 'number' && Number.isFinite(raw)) return raw
  const s = String(raw).trim()
  if (RE_MX.test(s)) {
    const tMx = Date.parse(`${s.replace(' ', 'T')}-06:00`)
    if (Number.isFinite(tMx)) return tMx
  }
  const isoLike = s.includes('T') ? s : s.replace(' ', 'T')
  const t = Date.parse(isoLike)
  if (Number.isFinite(t)) return t
  const t2 = new Date(s).getTime()
  return Number.isFinite(t2) ? t2 : 0
}

export function chatVentanaAbierta (chat) {
  if (!chat) return false
  if (chat.tiemporestante != null && chat.tiemporestante !== '') {
    return Number(chat.tiemporestante) > 0
  }
  return Number(chat.ventanaCerrada) === 0
}

export const ID_ETIQUETA_INSCRITO = 5
export const ID_ETIQUETA_SPAM = 7
export const ID_ETIQUETA_NO_CONTESTA = 9
export const ID_ETIQUETA_NO_INTERESADO = 10

const ETIQUETAS_RECHAZO_NOMBRE = ['SPAM', 'NO INTERESADO', 'CLIENTE NO CONTESTA', 'RECHAZADO']

export function esEtiquetaSpam (chat) {
  if (!chat) return false
  if (Number(chat.idetiquetas) === ID_ETIQUETA_SPAM) return true
  return String(chat.etiqueta || '').trim().toUpperCase() === 'SPAM'
}

/** SPAM / no interesado / no contesta / rechazado: no cuentan como sin responder. */
export function esEtiquetaRechazada (chat) {
  if (!chat) return false
  const id = Number(chat.idetiquetas)
  if (id === ID_ETIQUETA_SPAM || id === ID_ETIQUETA_NO_INTERESADO || id === ID_ETIQUETA_NO_CONTESTA) {
    return true
  }
  const nombre = String(chat.etiqueta || chat.text || '').trim().toUpperCase()
  return ETIQUETAS_RECHAZO_NOMBRE.includes(nombre)
}

export function esEtiquetaInscrito (chat) {
  if (!chat) return false
  if (Number(chat.inscrito) === 1) return true
  if (Number(chat.idetiquetas) === ID_ETIQUETA_INSCRITO) return true
  return String(chat.etiqueta || chat.text || '').trim().toUpperCase() === 'INSCRITO'
}

export function esContactoCerrado (chat) {
  return Number(chat && chat.finalizo) === 1
}

/** Último mensaje visible es del cliente (no IA / no nosotros). Acepta 0, '0' y false (TINYINT). */
export function ultimoMensajeEsDelCliente (chat) {
  if (!chat || chat.mio == null || chat.mio === '') return false
  return Number(chat.mio) === 0
}

/** Solo la fecha que muestra la lista: YYYY-MM-DD HH:mm:ss o ISO convertible. */
export function fechaListaMexico (raw) {
  if (raw == null || raw === '') return ''
  if (raw instanceof Date) return formatFechaMexicoFront(raw)
  if (typeof raw === 'number' && Number.isFinite(raw)) return formatFechaMexicoFront(raw)
  const s = String(raw).trim()
  if (RE_MX.test(s)) return s
  if (/^\d{4}-\d{2}-\d{2}T/.test(s)) return formatFechaMexicoFront(s)
  return ''
}

/**
 * Igual que el botón de sin responder (mio == 0), sin etiqueta de rechazo/SPAM
 * y con ventana abierta (chip rojo / tiemporestante <= 0 no cuenta).
 */
export function esChatSinContestar (chat) {
  if (!chat) return false
  if (esEtiquetaRechazada(chat) || esEtiquetaInscrito(chat)) return false
  if (!chatVentanaAbierta(chat)) return false
  return chat.mio == 0
}

export const ID_ETIQUETA_BUSCA_EMPLEO = 16
export const ID_SIN_2DA_VUELTA = 'sin_2da_vuelta'
export const USUARIOS_SIN_2DA_VUELTA = [1, 334, 568, 626, 2767, 3219]

const ETIQUETAS_SIN_2DA_VUELTA_EXCLUIDAS = [
  ID_ETIQUETA_SPAM,
  ID_ETIQUETA_NO_INTERESADO,
  ID_ETIQUETA_INSCRITO,
  ID_ETIQUETA_BUSCA_EMPLEO,
]
const MS_HORA = 60 * 60 * 1000
const MS_SIN_2DA_VUELTA = 4 * MS_HORA
const HORA_INICIO_CONTEO = 10
const HORA_FIN_CONTEO = 20

/** "YYYY-MM-DD HH:mm:ss" México como ms "naive" (sin zona) para restar horas de reloj. */
function msNaiveMexico (raw) {
  const s = fechaListaMexico(raw)
  if (!s) return 0
  return Date.UTC(
    Number(s.slice(0, 4)),
    Number(s.slice(5, 7)) - 1,
    Number(s.slice(8, 10)),
    Number(s.slice(11, 13)),
    Number(s.slice(14, 16)),
    Number(s.slice(17, 19))
  )
}

/** Tiempo entre dos fechas contando solo de 10:00 a 20:00 (hora México). */
export function msHabilesEntre (desde, hasta) {
  const ini = msNaiveMexico(desde)
  const fin = msNaiveMexico(hasta)
  if (!ini || !fin || fin <= ini) return 0
  let total = 0
  const unDia = 24 * MS_HORA
  for (let dia = ini - (ini % unDia); dia < fin; dia += unDia) {
    const desdeTramo = Math.max(ini, dia + HORA_INICIO_CONTEO * MS_HORA)
    const hastaTramo = Math.min(fin, dia + HORA_FIN_CONTEO * MS_HORA)
    if (hastaTramo > desdeTramo) total += hastaTramo - desdeTramo
  }
  return total
}

/**
 * Último mensaje lo escribió una vendedora (no bot), pasaron 4 h hábiles
 * y la ventana de 24 h sigue abierta.
 */
export function esSinSegundaVuelta (chat, ahora = formatFechaMexicoFront()) {
  if (!chat || Number(chat.mio) !== 1 || !chat.fecha_ultimo_humano) return false
  if (ETIQUETAS_SIN_2DA_VUELTA_EXCLUIDAS.includes(Number(chat.idetiquetas))) return false
  if (!chatVentanaAbierta(chat)) return false
  return msHabilesEntre(chat.fecha_ultimo_humano, ahora) >= MS_SIN_2DA_VUELTA
}

/**
 * Misma fecha que muestra la lista (fecha_ultimo_mensaje).
 * No usar ultimmensaje (puede ser solo hora) ni fecha_ultimo_mensaje_cliente (ISO/UTC).
 */
export function fechaMensajeSinContestarMs (chat) {
  if (!esChatSinContestar(chat)) return 0
  const mx = fechaListaMexico(chat.fecha_ultimo_mensaje)
  if (!mx) return 0
  return fechaUltimoMensajeMs({ fecha_ultimo_mensaje: mx })
}

/** Recorta HH:mm de "YYYY-MM-DD HH:mm:ss" para que coincida con la lista. */
export function formatearHoraDesdeFechaLista (raw, ms) {
  const s = String(raw || '').trim()
  if (RE_MX.test(s)) {
    const hora = s.slice(11, 16)
    const fecha = s.slice(0, 10)
    const hoy = formatFechaMexicoFront(Date.now()).slice(0, 10)
    if (fecha === hoy) return hora
    return `${s.slice(8, 10)}/${s.slice(5, 7)} ${hora}`
  }
  return formatearHoraSinContestar(ms)
}

/** Hoy: HH:mm. Otro día: DD/MM HH:mm (zona México). */
export function formatearHoraSinContestar (ms) {
  if (!ms) return '—'
  const s = formatFechaMexicoFront(ms)
  const hora = s.slice(11, 16)
  const fecha = s.slice(0, 10)
  const hoy = formatFechaMexicoFront(Date.now()).slice(0, 10)
  if (fecha === hoy) return hora
  const parts = fecha.split('-')
  return `${parts[2]}/${parts[1]} ${hora}`
}

export const MS_SLA_SIN_CONTESTAR = 10 * 60 * 1000

export function esHoraSinContestarAtrasada (ms, now = Date.now()) {
  if (!ms) return false
  return (now - ms) > MS_SLA_SIN_CONTESTAR
}

/** Verde: ≤10 min desde el último sin contestar mostrado. Rojo: más de 10 min. Gris: sin pendiente. */
export function colorHoraSinContestar (ms, now = Date.now()) {
  if (!ms) return 'grey'
  return esHoraSinContestarAtrasada(ms, now) ? 'error' : 'green'
}

export function colorHoraSinContestarGrupo (map, now = Date.now()) {
  return colorHoraSinContestar(maxHoraSinContestarDeMap(map).horaSinContestarTodosMs, now)
}

export function claseTextoHoraSinContestar (color) {
  if (color === 'error') return 'error--text font-weight-bold'
  if (color === 'green') return 'success--text font-weight-medium'
  return 'grey--text'
}

/** Misma fecha que pinta la lista (horaChat). */
export function rawFechaListaChat (chat) {
  if (!chat) return ''
  return chat.fecha_ultimo_mensaje || chat.ultimmensaje || chat.ultimomensaje || ''
}

export function aplicarHoraSinContestar (entry, chat) {
  if (!entry) return
  const raw = rawFechaListaChat(chat)
  const mx = fechaListaMexico(raw) || fechaListaMexico(chat && chat.fecha_ultimo_mensaje)
  const ms = fechaMensajeSinContestarMs(chat)
  if (!ms || !mx) return
  const prev = Number(entry.horaSinContestarMs) || 0
  // El último de la lista de sin responder (más reciente arriba) es el más antiguo.
  if (!prev || ms < prev) {
    entry.horaSinContestarMs = ms
    entry.horaSinContestar = formatearHoraDesdeFechaLista(mx, ms)
  }
}

/** Mismo remap que filterChats: reasignados cuentan como sin responder (mio == 0). */
export function remapChatsSinResponder (chats) {
  return (Array.isArray(chats) ? chats : []).map((el) => {
    if (!el || Number(el.reasignado) !== 1) return el
    const sinleer = Math.max(Number(el.sinleer) || 0, 1)
    if (sinleer === Number(el.sinleer) && el.mio == 0) return el
    return { ...el, sinleer, mio: 0 }
  })
}

/**
 * Menú de encargadas: todas las vendedoras (menu) se conservan.
 * Si hay una seleccionada, su hora sale de la lista visible (filterChats).
 */
export function chatsParaHoraMenuEncargadas (menu, listaVisible, idVendedoraSel) {
  const menuArr = remapChatsSinResponder(menu)
  const lista = Array.isArray(listaVisible) ? listaVisible : []
  const idSel = Number(idVendedoraSel) || 0
  if (!(idSel > 0)) return menuArr.length ? menuArr : lista

  const deLista = lista.filter((c) => c && Number(c.usuario_asignado) === idSel)
  const resto = menuArr.filter((c) => Number(c.usuario_asignado) !== idSel)
  const deSel = deLista.length
    ? deLista
    : menuArr.filter((c) => Number(c.usuario_asignado) === idSel)
  return resto.concat(deSel)
}

export function maxHoraSinContestarDeMap (map) {
  let minMs = 0
  let hora = '—'
  Object.keys(map || {}).forEach((id) => {
    const entry = map[id]
    const ms = Number(entry && entry.horaSinContestarMs) || 0
    if (!ms) return
    if (!minMs || ms < minMs) {
      minMs = ms
      hora = (entry && entry.horaSinContestar) || formatearHoraSinContestar(ms)
    }
  })
  return {
    horaSinContestarTodosMs: minMs,
    horaSinContestarTodos: hora,
  }
}

/**
 * Abiertas (verde/amarillo) primero; cerradas al final.
 * Dentro de cada grupo: más reciente, luego sin leer.
 */
export function ordenarChatsPorMasReciente (lista) {
  return (Array.isArray(lista) ? lista : []).slice().sort((a, b) => {
    const abiertaA = chatVentanaAbierta(a) ? 1 : 0
    const abiertaB = chatVentanaAbierta(b) ? 1 : 0
    if (abiertaB !== abiertaA) return abiertaB - abiertaA

    const tb = fechaUltimoMensajeMs(b)
    const ta = fechaUltimoMensajeMs(a)
    if (tb !== ta) return tb - ta
    return (Number(b.sinleer) || 0) - (Number(a.sinleer) || 0)
  })
}
